(function() {
    'use strict';

    angular
        .module('doctorclubboApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('opzioni-ticket', {
            parent: 'entity',
            url: '/opzioni-ticket?page&sort&search',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'doctorclubboApp.opzioni_ticket.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/opzioni-ticket/opzioni-tickets.html',
                    controller: 'Opzioni_ticketController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'id,asc',
                    squash: true
                },
                search: null
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort),
                        search: $stateParams.search
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('opzioni_ticket');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('opzioni-ticket-detail', {
            parent: 'opzioni-ticket',
            url: '/opzioni-ticket/{id}',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'doctorclubboApp.opzioni_ticket.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/opzioni-ticket/opzioni-ticket-detail.html',
                    controller: 'Opzioni_ticketDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('opzioni_ticket');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'Opzioni_ticket', function($stateParams, Opzioni_ticket) {
                    return Opzioni_ticket.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'opzioni-ticket',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        .state('opzioni-ticket-detail.edit', {
            parent: 'opzioni-ticket-detail',
            url: '/detail/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/opzioni-ticket/opzioni-ticket-dialog.html',
                    controller: 'Opzioni_ticketDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Opzioni_ticket', function(Opzioni_ticket) {
                            return Opzioni_ticket.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('opzioni-ticket.new', {
            parent: 'opzioni-ticket',
            url: '/new',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/opzioni-ticket/opzioni-ticket-dialog.html',
                    controller: 'Opzioni_ticketDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                importo: null,
                                num: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('opzioni-ticket', null, { reload: 'opzioni-ticket' });
                }, function() {
                    $state.go('opzioni-ticket');
                });
            }]
        })
        .state('opzioni-ticket.edit', {
            parent: 'opzioni-ticket',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/opzioni-ticket/opzioni-ticket-dialog.html',
                    controller: 'Opzioni_ticketDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Opzioni_ticket', function(Opzioni_ticket) {
                            return Opzioni_ticket.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('opzioni-ticket', null, { reload: 'opzioni-ticket' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('opzioni-ticket.delete', {
            parent: 'opzioni-ticket',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/opzioni-ticket/opzioni-ticket-delete-dialog.html',
                    controller: 'Opzioni_ticketDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['Opzioni_ticket', function(Opzioni_ticket) {
                            return Opzioni_ticket.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('opzioni-ticket', null, { reload: 'opzioni-ticket' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();
